import { render, staticRenderFns } from "./ItemsList.vue?vue&type=template&id=488c9c1a&scoped=true&"
import script from "./ItemsList.vue?vue&type=script&lang=ts&"
export * from "./ItemsList.vue?vue&type=script&lang=ts&"
import style0 from "./ItemsList.vue?vue&type=style&index=0&id=488c9c1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488c9c1a",
  null
  
)

export default component.exports